export const measurementReportWateringTypeValues = [
    'irrigation',
    'dripIrrigation',
    'rainfalls'
];
export const measurementReportTypeValues = [
    ...measurementReportWateringTypeValues,
    'dryMatter',
    'ASES'
];
export const isMeasurementReportType = (value) => {
    return measurementReportTypeValues.includes(value);
};
